import { createIcon } from '@chakra-ui/react'

export const Info = createIcon({
  displayName: 'Info',
  viewBox: '0 0 48 48',
  d:
    'M24 0.667969C11.12 0.667969 0.666656 11.1213 0.666656 24.0013C0.666656 36.8813 11.12 47.3346 24 47.3346C36.88 47.3346 47.3333 36.8813 47.3333 24.0013C47.3333 11.1213 36.88 0.667969 24 0.667969ZM26.3333 35.668H21.6667V21.668H26.3333V35.668ZM26.3333 17.0013H21.6667V12.3346H26.3333V17.0013Z',
})
